module.exports = {
  "dof-numcard-row": {
    "flexDirection": "row",
    "flexWrap": "nowrap",
    "overflow": "hidden"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-4a1de980!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-numcard-row/index.vue
// module id = 462
// module chunks = 0 1